module.exports = __webpack_public_path__ + "img/4_x8.835ece9f.png";